<template>
    <div class="overlay" @click.self="closePopup">
      <div class="popup">
        <h2>{{Header}}</h2>
        <div class="form-group">
            {{ MainText }}
        </div>
        <div class="button-group">
          <button @click="confirmRequest" >{{ $t('Confirmation.Confirm') }}</button>
          <button @click="closePopup">{{ $t('SaveFile.Cancel') }}</button>
        </div>
      </div>
    </div>
  </template>
  <script>
  
  
  export default {
    props: ["Header", "MainText"],
    name: 'ConfirmationModal',
    methods: {
        confirmRequest() {
        this.$emit('confirm');
        this.$emit('close');
      },
      closePopup() {
        this.$emit('close');
      },
    },
  };
  </script>
  
  <style scoped>
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .popup {
    background: white;
    color: black;
    padding: 20px;
    border-radius: 8px;
    width: 300px;
    text-align: left;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  label {
    display: block;
    margin-bottom: 5px;
  }
  
  input,
  select {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
  }
  
  .invalid {
    border-color: red;
  }
  
  .error-message {
    color: red;
    font-size: 12px;
  }
  
  .button-group {
    display: flex;
    justify-content: space-between;
  }
  
  button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  </style>